
import { useQuery } from "@tanstack/react-query";
import { Users, ClipboardList, Package } from "lucide-react";
import StatCard from "@/components/dashboard/StatCard";
import { supabase } from "@/integrations/supabase/client";

const DashboardPage = () => {
  // Query for user count
  const { data: userCount = 0 } = useQuery({
    queryKey: ['userCount'],
    queryFn: async () => {
      const { count } = await supabase
        .from('user_profiles')
        .select('*', { count: 'exact', head: true });
      return count || 0;
    },
  });

  // Query for access request count
  const { data: requestCount = 0 } = useQuery({
    queryKey: ['requestCount'],
    queryFn: async () => {
      const { count } = await supabase
        .from('access_requests')
        .select('*', { count: 'exact', head: true });
      return count || 0;
    },
  });

  // Query for product count
  const { data: productCount = 0 } = useQuery({
    queryKey: ['productCount'],
    queryFn: async () => {
      const { count } = await supabase
        .from('products')
        .select('*', { count: 'exact', head: true });
      return count || 0;
    },
  });

  // Query for pending requests
  const { data: pendingRequestCount = 0 } = useQuery({
    queryKey: ['pendingRequestCount'],
    queryFn: async () => {
      const { count } = await supabase
        .from('access_requests')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'pending');
      return count || 0;
    },
  });

  return (
    <div className="container mx-auto py-8 px-4">
      <h1 className="text-2xl font-bold mb-6">Dashboard Overview</h1>
      
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Total Users"
          value={userCount}
          icon={Users}
          description="Registered users in the system"
        />
        
        <StatCard
          title="Access Requests"
          value={requestCount}
          icon={ClipboardList}
          description={`${pendingRequestCount} pending`}
        />
        
        <StatCard
          title="Products"
          value={productCount}
          icon={Package}
          description="Total products in marketplace"
        />
      </div>
    </div>
  );
};

export default DashboardPage;
